module.exports = __webpack_public_path__ + "img/BishopFlunder.6b65dcb2.jpg";